export default __webpack_public_path__ + "static/media/rc-icon.931d1ee9.svg";